import * as actions from "./actions";
import * as loanActions from "../loan/actions";
import _ from "underscore";

import moment from "moment";

let initialState = {
  fetching: false,
  fetched: false,
  error: null,
  data: [],

  detailsFetching: false,
  detailsFetched: false,
  detailsError: null,

  table: {
    currentFilter: null,
    pagination: { page: 1, take: 10 },
  },
  loansAreUpdating: false,
};

const creditSettlement = (state = initialState, action) => {
  switch (action.type) {
    // GET SETTLEMENTS AND DETAILS
    case actions.CREDIT_SETTLEMENT_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
        error: null,
        data: null,
      });
    case actions.CREDIT_SETTLEMENT_LIST_GET_SUCCESS:
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        data: action.response.Response,
      });
    case actions.CREDIT_SETTLEMENT_LIST_GET_ERROR:
      return Object.assign({}, state, {
        fetching: false,
        error: action.error,
      });
    case actions.CREDIT_SETTLEMENT_LIST_GET_DETAILS_REQUEST:
      return Object.assign({}, state, {
        detailsFetching: true,
        detailsError: null,
      });
    case actions.CREDIT_SETTLEMENT_LIST_GET_DETAILS_SUCCESS:
      var forId = action.additionalData;

      var itemToUpdateIndex = _.findIndex(state.data, (item) => {
        return item.Id === forId;
      });

      // There is a mismatch between backend objects it needs to be done like that unfortunately ;/
      // TODO change it later
      action.response.Id = action.response.IntId;
      action.response = {
        ...state.data[itemToUpdateIndex],
        ...action.response,
      };

      return Object.assign({}, state, {
        detailsFetching: false,
        detailsFetched: true,
        data: [
          ...state.data.slice(0, itemToUpdateIndex),
          action.response,
          ...state.data.slice(itemToUpdateIndex + 1),
        ],
      });
    case actions.CREDIT_SETTLEMENT_LIST_GET_DETAILS_ERROR:
      return Object.assign({}, state, {
        detailsFetching: false,
        detailsError: action.error,
      });

    //OTHER
    case actions.LOAN_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loansAreUpdating: true,
      });
    case actions.LOAN_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        loansAreUpdating: false,
      });
    case actions.LOAN_UPDATE_ERROR:
      return Object.assign({}, state, {
        loansAreUpdating: JSON.stringify(action.error),
      });

    // table actions
    case loanActions.LOAN_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        table: Object.assign({}, state.table, {
          pagination: Object.assign({}, state.table.pagination, {
            page: action.page,
          }),
        }),
      });

    case loanActions.LOAN_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        table: Object.assign({}, state.table, {
          currentFilter: Object.assign({}, state.table.currentFilter, {
            ...action.filter,
          }),
        }),
      });

    // Getting full repayment
    case loanActions.GET_REPAYMENT_REQUEST: {
      let id = action.dataSent.CreditId;

      let loanIndex = _.findIndex(state.data, (loan) => {
        return loan.Id == id;
      });

      let loanItem = Object.assign({}, state.data[loanIndex]);

      loanItem.fullRepaymentLoading = true;

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, loanIndex),
          loanItem,
          ...state.data.slice(loanIndex + 1),
        ],
      });
    }

    case loanActions.LOAN_REPAYMENT_REQUEST: {
      let guid = action.dataSent.CreditId;
      let loanIndex = _.findIndex(state.data, (loan) => {
        return loan.Guid == guid;
      });

      let loanItem = Object.assign({}, state.data[loanIndex]);

      loanItem.fullRepaymentCreatedByAdminLoading = true;
      loanItem.fullRepaymentCreatedByAdminError = false;

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, loanIndex),
          loanItem,
          ...state.data.slice(loanIndex + 1),
        ],
      });
    }
    //data: { LoanId: loanId, Amount: amount, BankReceiveDate: date },
    case loanActions.LOAN_REPAYMENT_SUCCESS: {
      let guid = action.dataSent.CreditId;

      let loanIndex = _.findIndex(state.data, (loan) => {
        return loan.Guid == guid;
      });

      let loanItem = Object.assign({}, state.data[loanIndex]);

      loanItem.fullRepaymentCreatedByAdminDone = action.response;
      loanItem.fullRepaymentCreatedByAdminLoading = false;

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, loanIndex),
          loanItem,
          ...state.data.slice(loanIndex + 1),
        ],
      });
    }
    case loanActions.LOAN_REPAYMENT_ERROR: {
      let guid = action.dataSent.CreditId;

      let loanIndex = _.findIndex(state.data, (loan) => {
        return loan.Guid == guid;
      });

      let loanItem = Object.assign({}, state.data[loanIndex]);

      loanItem.fullRepaymentCreatedByAdminError = true;
      loanItem.fullRepaymentCreatedByAdminLoading = false;

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, loanIndex),
          loanItem,
          ...state.data.slice(loanIndex + 1),
        ],
      });
    }

    case loanActions.GET_REPAYMENT_SUCCESS: {
      let id = action.dataSent.CreditId;

      let loanIndex = _.findIndex(state.data, (loan) => {
        return loan.Id == id;
      });

      let loanItem = Object.assign({}, state.data[loanIndex]);

      loanItem.fullRepayment = action.response;
      loanItem.fullRepaymentLoading = false;

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, loanIndex),
          loanItem,
          ...state.data.slice(loanIndex + 1),
        ],
      });
    }
    // Fee remove
    case loanActions.REMOVE_FEES_REQUEST: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      let toChange = Object.assign({}, state.data[toChangeIndex], {
        sending: true,
        sent: false,
        error: null,
      });

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, toChangeIndex),
          toChange,
          ...state.data.slice(toChangeIndex + 1),
        ],
      });
    }
    case loanActions.REMOVE_FEES_SUCCESS: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      let toChange = Object.assign({}, state.data[toChangeIndex], {
        sending: false,
        sent: true,
        error: null,
      });

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, toChangeIndex),
          toChange,
          ...state.data.slice(toChangeIndex + 1),
        ],
      });
    }
    case loanActions.REMOVE_FEES_ERROR: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      let toChange = Object.assign({}, state.data[toChangeIndex], {
        sending: false,
        sent: false,
        error: action.error,
      });

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, toChangeIndex),
          toChange,
          ...state.data.slice(toChangeIndex + 1),
        ],
      });
    }

    case loanActions.LOAN_SET_TO_DISPUTED_SUCCESS: {
      const id = action.dataSent.LoanId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id === id;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          DisputedSince: moment(new Date()).format("YYYY-MM-DD"),
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }

    case loanActions.LOAN_SET_TO_UNDISPUTED_SUCCESS: {
      const id = action.dataSent.LoanId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id === id;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          DisputedSince: null,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }

    default:
      return state;
  }
};

export default creditSettlement;
